import { render } from "./Chase.vue?vue&type=template&id=2e06f02a"
import script from "./Chase.vue?vue&type=script&lang=js"
export * from "./Chase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__